import { createAsyncThunk, createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SYSTEM_SETTINGS } from '../../Constants/ApiDefinations'
import mainApiService from '../../Services'

interface SystemSettingsState {
  maintenanceMode: boolean | null
  error: string | null
}

const initialState: SystemSettingsState = {
  maintenanceMode: null,
  error: null,
}

const systemSettingsSlice = createSlice({
  name: 'systemSettings',
  initialState,
  reducers: {
    setMaintenanceMode: (state, action: PayloadAction<boolean>) => {
      state.maintenanceMode = action.payload
    },
    clearSystemSettings: (state) => {
      state.maintenanceMode = null
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch maintenance status
      .addCase(fetchMaintenanceStatus.pending, (state) => {
        state.error = null
      })
      .addCase(fetchMaintenanceStatus.fulfilled, (state, action) => {
        if (action.payload?.data?.settingValue !== undefined) {
          state.maintenanceMode = action.payload.data.settingValue
        }
      })
      .addCase(fetchMaintenanceStatus.rejected, (state, action) => {
        state.error = action.error.message || 'Failed to fetch maintenance status'
      })
      // Update maintenance status
      .addCase(updateMaintenanceStatus.pending, (state) => {
        state.error = null
      })
      .addCase(updateMaintenanceStatus.fulfilled, (state, action) => {
        state.maintenanceMode = action.payload
      })
      .addCase(updateMaintenanceStatus.rejected, (state, action) => {
        state.error = action.error.message || 'Failed to update maintenance status'
      })
  },
})

export const { setMaintenanceMode, clearSystemSettings } = systemSettingsSlice.actions

export const fetchMaintenanceStatus = createAsyncThunk(
  'systemSettings/fetchMaintenanceStatus',
  async () => {
    const apiConfig = SYSTEM_SETTINGS.GET_STATUS()
    const response: any = await mainApiService(apiConfig)
    return response
  },
)

export const updateMaintenanceStatus = createAsyncThunk(
  'systemSettings/updateMaintenanceStatus',
  async (settingValue: boolean) => {
    const apiConfig = SYSTEM_SETTINGS.UPDATE_STATUS({
      settingId: 'MAINTENANCE_MODE',
      settingValue,
    })
    await mainApiService(apiConfig)
    return settingValue
  },
)

const systemSettingsSelector = (state: { systemSettings: SystemSettingsState }) =>
  state.systemSettings

export const selectMaintenanceMode = createSelector(
  systemSettingsSelector,
  (state) => state.maintenanceMode,
)

export const selectSystemSettingsError = createSelector(
  systemSettingsSelector,
  (state) => state.error,
)

export default systemSettingsSlice
